<template>
    <v-container>
      <v-row class="justify-center">
          <v-col cols="12">
              <v-img
                  :src="require('@/assets/img/intro/self.png')"
                  contain
                  height="300"
              />
          </v-col>
          <v-col cols="12" lg="6" xl="6">
              <h1 class="mb-6 text-center page-header d-flex justify-center">
                  <span>Hey there</span>
                  <div class="waving-hand mx-1">👋</div>
                  <span>, I'm Andy</span>
              </h1>
              <div class="text-center">
                  <p>
                    I am a Full Stack Software Developer based in the Greater Toronto Area that is currently working at TripSpark Technologies. I have 
                    experience and exposure in a variety of languages including C++, C# (.NET/ASP.NET), SQL and Vue.js, but love to learn more! I am a time-managed, organized and detail-oriented
                    individual that is always working to improve designs.
                  </p>
                  <p>
                    <span>
                      When I am not behind a computer, you can find me hanging out with friends and family, as well as playing sports. 
                      I will try any sport, but my favourite sport is hockey (GO LEAFS GO!
                    </span>
                    <img width="16" :src="require('@/assets/img/intro/toronto-maple-leafs.png')" />
                    <span>
                      ). I have actually partipated in numerous ball hockey tournaments around the Toronto area.
                    </span>
                  </p>
              </div>
          </v-col>
      </v-row>
      <v-row class="justify-center" v-for="(entry, i) in tags" :key="i">
        <v-col cols="12" lg="6" xl="6">
          <div class="font-weight-bold">{{ entry.title }}</div>
          <v-chip-group column class="read-only-chips">
            <v-chip v-for="tag in entry.tags" :key="tag" disabled dark>
              {{ tag }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'About',
    data: function() {
      return {
        tags: [
          {
            title: 'Languages',
            tags: [ 
              'C++', 'C#', 'SQL (MSSQL)', 'HTML', 'CSS/SCSS', 'JavaScript', 'TypeScript' 
            ]
          },
          {
            title: 'Technologies, Frameworks and Tools',
            tags: [ 
              'Vue.js', 'Vuetify', '.NET/ASP.NET Core', 'Entity Framework Core', 'Git', 'SVN', 'Visual Studio', 'Jira', 'Confluence', 'Unit Testing', 'Agile (Scrum)' 
            ]
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

.waving-hand {
    animation: rotate-icon 0.8s ease-in;
}

@keyframes rotate-icon {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(6deg);
  }
  20% {
    transform: rotate(12deg);
  }
  30% {
    transform: rotate(18deg);
  }
  40% {
    transform: rotate(24deg);
  }
  50% {
    transform: rotate(30deg);
  }
  60% {
    transform: rotate(24deg);
  }
  70% {
    transform: rotate(18deg);
  }
  80% {
    transform: rotate(12deg);
  }
  90% {
    transform: rotate(6deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

</style>